import { render, staticRenderFns } from "./AuthorView.vue?vue&type=template&id=024d06c5&scoped=true"
import script from "./AuthorView.vue?vue&type=script&lang=js"
export * from "./AuthorView.vue?vue&type=script&lang=js"
import style0 from "./AuthorView.vue?vue&type=style&index=0&id=024d06c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024d06c5",
  null
  
)

export default component.exports